"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.grade.title': 'Ulepsz konto',
    'user.grade.free': 'Darmowy',
    'user.grade.basic': 'Podstawowy',
    'user.grade.pro': 'Pro',
    'user.grade.ultra': 'Ultra',
};
